/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Detail_DepositInputs */

const en_campaigns_mag7_spacex_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposit to enroll. Glider builds the strategy in your own account.`)
};

const de_campaigns_mag7_spacex_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlen Sie ein, um teilzunehmen. Glider baut die Strategie in Ihrem eigenen Konto auf.`)
};

const pt_br2_campaigns_mag7_spacex_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposite para participar. A Glider monta a estratégia na sua própria conta.`)
};

const tr_campaigns_mag7_spacex_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katılmak için para yatırın. Glider, stratejiyi kendi hesabınızda oluşturur.`)
};

const zh_cn2_campaigns_mag7_spacex_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存入资金即可参与。Glider 会在你自己的账户中构建该策略。`)
};

const zh_hk2_campaigns_mag7_spacex_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存入資金即可參加。Glider 會在你自己的帳戶中建立該策略。`)
};

const ko_kr2_campaigns_mag7_spacex_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`참여하려면 입금하세요. Glider가 본인 계정에 전략을 구성합니다.`)
};

const ru_ru2_campaigns_mag7_spacex_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внесите депозит, чтобы участвовать. Glider соберёт стратегию в вашем собственном аккаунте.`)
};

const es_419_campaigns_mag7_spacex_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposita para inscribirte. Glider arma la estrategia en tu propia cuenta.`)
};

/**
* | output |
* | --- |
* | "Deposit to enroll. Glider builds the strategy in your own account." |
*
* @param {Campaigns_Mag7_Spacex_Detail_DepositInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_detail_deposit = /** @type {((inputs?: Campaigns_Mag7_Spacex_Detail_DepositInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Detail_DepositInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_detail_deposit(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_detail_deposit(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_detail_deposit(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_detail_deposit(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_detail_deposit(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_detail_deposit(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_detail_deposit(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_detail_deposit(inputs)
	return es_419_campaigns_mag7_spacex_detail_deposit(inputs)
});